import React from 'react';
import { IonContent, IonList, IonItem, IonLabel, IonIcon } from '@ionic/react';
import { logOutOutline } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';
import NavigationMenu from '../../shared/NavigationMenu';
import AuthService from '../../../services/auth';
import './MobileSidebar.css';

const MobileSidebar = ({ user }) => {
  const { t } = useTranslation();

  const handleLogout = () => {
    AuthService.logout();
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  return (
    <IonContent className="mobile-sidebar-content">
      <div className="sidebar-content">
        {user && (
          <div className="sidebar-user">
            <div className="user-info">
              <div className="user-avatar">
                {getInitials(user.name || user.email)}
              </div>
              <h3 className="user-name">{user.name || 'User'}</h3>
              <p className="user-plan">{user.email}</p>
            </div>
          </div>
        )}
        
        <NavigationMenu isMobile={true} />
        
        {user && (
          <div className="mobile-sidebar-logout">
            <IonList>
              <IonItem button onClick={handleLogout}>
                <IonLabel>{t('nav.logout')}</IonLabel>
                <IonIcon icon={logOutOutline} slot="end" />
              </IonItem>
            </IonList>
          </div>
        )}
      </div>
    </IonContent>
  );
};

export default MobileSidebar;

